module.exports = __webpack_public_path__ + "img/GTR.afc8172.jpg";